import { createRoute, useEntityUrl } from 'framework/routing';

const PAYROLL_REPORT_PATH = '/payroll/report';

export const getPayrollListUrl = () => PAYROLL_REPORT_PATH;

export const getPayrollRouterPath = () => `${PAYROLL_REPORT_PATH}/*`;

export const usePayrollRoute = () => createRoute({ listRoute: PAYROLL_REPORT_PATH });

export const usePayrollUrl = () =>
  useEntityUrl({
    baseLink: PAYROLL_REPORT_PATH,
  });
